import React from 'react';
const frictions = ['Another class to build.', 'Another set of exercises to find.', 'Another circuit to organize.', 'Another group with different ability levels.', 'Another progression to figure out.', 'Another week wondering what comes next.'];
export function ProblemSection() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-173" data-mp="2vq7medgux0ow">
      <div className="max-w-3xl mx-auto" data-id="element-174" data-mp="39hvzok2udv7g">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-2" data-id="element-175" data-mp="39gupehtnhcqs">
          You already know how to coach.
        </h2>
        <p className="font-heading font-semibold uppercase text-[11px] sm:text-sm tracking-wide text-green-dark text-center leading-snug mb-6 max-w-xl mx-auto" data-id="element-176" data-mp="3jf0okro2o4ry">
          The problem is everything you have to prepare before the class even
          starts.
        </p>

        <ul className="max-w-md mx-auto mb-6" data-id="element-177" data-mp="1k37naiu94d9f">
          {frictions.map(item => <li key={item} className="flex items-baseline gap-2.5 border-b border-petrol/10 py-2 last:border-b-0" data-id="element-178" data-mp="jd3n6mw0u9qw">
              <span className="text-green font-heading font-black text-sm leading-none shrink-0" data-id="element-179" data-mp="oczoufh8xp3a">
                ×
              </span>
              <span className="text-[13px] sm:text-base font-medium text-petrol/80" data-id="element-180" data-mp="sbyslwr8rft5">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="text-[13px] sm:text-base text-petrol/75 leading-relaxed text-center max-w-xl mx-auto mb-5" data-id="element-181" data-mp="123360s19qslv">
          Your expertise shouldn't require you to spend your personal time
          searching, collecting and rebuilding your senior fitness programming
          every single week.
        </p>

        <p className="font-heading font-extrabold uppercase text-sm sm:text-lg leading-tight tracking-tight text-petrol text-center border-t-2 border-lime pt-5 max-w-lg mx-auto" data-id="element-182" data-mp="1g2kypihoqq0i">
          Your next class doesn't need to start with a blank page.
        </p>
      </div>
    </section>;
}